import { useMemo } from 'react';
import { FaChevronRight } from 'react-icons/fa';
import LocationOnOutlinedIcon from '@mui/icons-material/LocationOnOutlined';
import { useAors } from '../../hooks/useAors';
import { useAlertAcknowledgements } from '../DisasterGPTAlerts/hooks/useAlertAcknowledgements';
import { useSelector } from 'react-redux';
import { selectUserGuid } from '../../slices/commonSelectors';
import { AlertAcknowledgmentWarning } from '../DisasterGPTAlerts/components/AlertAcknowledgmentWarning';
import { GetSitrepsResponse } from 'components/Reports/reports.types';

type SitrepSidebarItemProps = {
  sitrep: GetSitrepsResponse;
  onClick: () => void;
};

const SitrepListItem = ({ sitrep, onClick }: SitrepSidebarItemProps) => {
  const { data: aors = [] } = useAors();
  const currentUserGuid = useSelector(selectUserGuid);

  const currentAorName = useMemo(
    () => aors.find((aor) => aor.id === sitrep.aor_id)?.name,
    [aors, sitrep.aor_id]
  );

  // Check if this is an alert sitrep that requires acknowledgment
  const isAlertSitrep = sitrep.sitrep_source === 'ALERT';
  const { data: acknowledgements = [] } = useAlertAcknowledgements(
    isAlertSitrep ? sitrep.sitrep_source_id : ''
  );

  const userAcknowledgement = acknowledgements.find(
    (ack) => ack.userGuid === currentUserGuid
  );
  const needsAcknowledgement =
    isAlertSitrep && userAcknowledgement && !userAcknowledgement.acknowledgedAt;
  return (
    <button
      onClick={onClick}
      onKeyDown={(e) => {
        if (e.target instanceof HTMLButtonElement) {
          // Prevent buttons in the row from triggering onClick for the row.
          return;
        }
        if (e.key === 'Enter' || e.key === ' ') {
          onClick();
        }
      }}
      className="sitrep-list-item"
    >
      <div className="information-container">
        <div className="sitrep-name-container">
          <h6>{sitrep.name || 'Untitled Sitrep'}</h6>
        </div>
        <div className="sitrep-description-container">
          <p>
            <i>{sitrep.description || 'No description available'}</i>
          </p>
        </div>
        {currentAorName && (
          <span className="sitrep-aor">
            <LocationOnOutlinedIcon />
            {currentAorName}
          </span>
        )}
      </div>
      <div className="arrow-container">
        {needsAcknowledgement && (
          <AlertAcknowledgmentWarning size="lg" className="me-2" />
        )}
        <FaChevronRight />
      </div>
    </button>
  );
};

export default SitrepListItem;
